import { Select } from "@shopify/polaris";
import {
  DO_NOT_REDIRECT,
  REDIRECT_CUSTOM_URL,
  REDIRECT_HOME_PAGE,
  REDIRECT_SPECIFIC_BLOG_POST,
  REDIRECT_SPECIFIC_PRODUCT_PAGE,
  REDIRECT_SPECIFIC_SHOPIFY_PAGE
} from "../../../../../../constants/redirectTypes.js";


const redirectOptions = [
  { label: "Redirect to Home Page", value: REDIRECT_HOME_PAGE },
  { label: "Redirect to a Specific Shopify Page", value: REDIRECT_SPECIFIC_SHOPIFY_PAGE },
  { label: "Redirect to a Specific Product Page", value: REDIRECT_SPECIFIC_PRODUCT_PAGE },
  { label: "Redirect to a Specific Blog Post", value: REDIRECT_SPECIFIC_BLOG_POST },
  { label: "Redirect to Custom URL", value: REDIRECT_CUSTOM_URL },
  { label: "Do not redirect", value: DO_NOT_REDIRECT }
];

const RedirectSelectField = ({ input }) => {
  return (
    <Select
      label="Redirect hidden products to"
      options={redirectOptions}
      onChange={input.onChange}
      value={input.value}
    />
  );
};

export default RedirectSelectField;